import PropTypes from "prop-types"
import React, { useEffect, useLayoutEffect, useRef, useState } from "react"
import { connect } from "react-redux"
import styled from "styled-components"

// const J3DViewHalfModalsWrapper = loadable(() =>
//   retry(() => import("areas/product/jewlr/modals/j3dview-half-modals-wrapper"))
// )

const Wrapper = styled.div`
  ${(props) => props.theme.mediaQueries.mobileOnly`
    min-height: unset !important;
  `}
`
const Container = styled.div`
  padding-bottom: 40px;
  @media (max-width: 767px) {
    width: auto !important;
    margin: 0 !important;
  }
  ${(props) => props.theme.mediaQueries.tablet`
      ${
        props.sticky &&
        `
        position: fixed;
      `
      }
  `}
`

let scrollTick = false

const InternalImageArea = ({
  children,
  endOffset,
  topOffset,
  wizardBodyRef,
}) => {
  const [margin, setMargin] = useState(0)
  const [top, setTop] = useState(0)
  const [sticky, setSticky] = useState(false)
  const [width, setWidth] = useState(null)
  const containerRef = useRef(null)
  const stickyRef = useRef(null)

  const requestScroll = () => {
    window.requestAnimationFrame(scrollListener)
  }

  const scrollListener = () => {
    if (!scrollTick) {
      scrollTick = true
      let scrollPos = window.scrollY
      let containerHeight = stickyRef.current?.offsetHeight
      let wizardBodyHeight = wizardBodyRef.current?.offsetHeight
      let end = wizardBodyHeight - containerHeight - endOffset
      if (scrollPos > end - topOffset) {
        setSticky(false)
        setMargin(end > 0 ? `${end}px` : 0)
        setTop(0)
      } else if (end > 0) {
        setSticky(true)
        setMargin(0)
        setTop(wizardBodyRef.current?.offsetTop + topOffset)
      }

      scrollTick = false
    }
  }

  useEffect(() => {
    if (wizardBodyRef.current) {
      document.addEventListener("scroll", requestScroll)
    }
    return () => {
      document.removeEventListener("scroll", requestScroll)
      if (wizardBodyRef.current) {
        setSticky(false)
        setMargin(0)
      }
    }
  }, [wizardBodyRef])

  if (typeof window !== "undefined") {
    useLayoutEffect(() => {
      const resizeListener = () => {
        window.requestAnimationFrame(() => {
          setWidth(`${containerRef.current?.offsetWidth}px`)
        })
      }
      window.addEventListener("resize", resizeListener)
      window.addEventListener("resize", requestScroll)
      return () => {
        window.removeEventListener("resize", resizeListener)
        window.removeEventListener("resize", requestScroll)
      }
    }, [])
  }

  return (
    <>
      <Wrapper
        ref={containerRef}
        style={{
          minHeight:
            containerRef.current && `${containerRef.current?.offsetHeight}px`,
        }}
      >
        <Container
          ref={stickyRef}
          sticky={sticky}
          style={{
            marginTop: margin,
            top,
            width: width
              ? width
              : containerRef.current &&
                `${containerRef.current?.offsetWidth}px`,
          }}
        >
          {children}
        </Container>
      </Wrapper>
      {/* <J3DViewHalfModalsWrapper /> */}
    </>
  )
}

InternalImageArea.propTypes = {
  children: PropTypes.any,
  endOffset: PropTypes.number,
  topOffset: PropTypes.number,
  wizardBodyRef: PropTypes.object,
}

InternalImageArea.defaultProps = {
  endOffset: 0,
  topOffset: 0,
}

const mapStateToProps = (state) => {
  return {
    showFlip: state.wizard.hasFaceComponentOptions,
    showUpload: state.wizard.hasImageOptions,
  }
}

const ImageArea = connect(mapStateToProps)(InternalImageArea)

export default ImageArea
